import { Injectable } from '@angular/core';
import { ContactPhoneService } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';
import { StarbaseComponentMessageService } from './starbase-component-message.service';

@Injectable({
  providedIn: 'root'
})
export class ContactPhonesService extends ContactPhoneService {

  constructor(sbCmpMsgSvc: StarbaseComponentMessageService, http: HttpClient, webApi: WebApiService) {
    super(sbCmpMsgSvc, http, webApi);
  }
}
